module.exports = __webpack_public_path__ + "static/media/favicon.97dc5f88.ico";